import React, { useState, useContext, useEffect,useCallback } from "react";
import context from "context/context";
import * as moment from "moment";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";
import ThriveServicePlusRequests from 'apis/ThriveServicePlusRequest/ThriveServicePlusRequest';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import useDebounce from 'helpers/useDebounce';
import { pdf } from '@react-pdf/renderer';
import ThriveServicePlusPDF from './ThriveServicePlusPDF';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Modal, Backdrop, Fade } from '@material-ui/core';



const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const formFields = [
  { label: "Henry Schein Account Number", key: "henry_schein_account_number" },
  { label: "Title", key: "title" },
  { label: "Practice Owner Name", key: "practice_owner_name" },
  { label: "Point of Contact", key: "point_of_contact" },
  { label: "Office Number", key: "office_number" },
  { label: "Preferred Contact Number", key: "preferred_contact_number" },
  { label: "Email", key: "email" },
  { label: "Practice Name", key: "practice_name" },
  { label: "Street Address", key: "street_address" },
  { label: "City", key: "city" },
  { label: "State", key: "state" },
  { label: "Zip Code", key: "zipcode" },
  { label: "Tier Service Agreement", key: "tier_service_agreement" },
]

function History(props) {
  const { state, dispatch } = useContext(context);
  const classes = styles();
  const goBack = props.goBack;

  const { getHistory ,searchhistory} = ThriveServicePlusRequests();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [previewData, setPreviewData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [imageType, setImageType] = useState('');
  const [states, setstates] = useState({ historyLoader: false,clearSearch: false });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);
  

  const { t } = useTranslation();

  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
});

  useEffect(() => {
    handleGet();
  }, [offset]);

  useEffect(() => {
    if (!states?.clearSearch) {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        }
        else {
          handleGet();
        }
    }
    else {
        setStates({ clearSearch: false });
    }
}, [searchBounceValues, offset]);


  // Breadcrumb
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "History"] });
  }, []);

  const handleGet = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getHistory(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (e) {
      console.log({ e });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleSearch = async () => {
    try {
      let values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchhistory(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (e) {
      console.log({ e });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handlePagination = (value) => {
    setOffset(value);
  };

  // Helper to format plan name (if needed)
  const getPlanName = (plan) => {
    if (!plan) return "-";
    const index = plan.indexOf("-");
    if (index === -1) {
      return plan.split(" ").slice(0, 2).join(" ");
    }
    return plan.substring(0, index).trim();
  };

  const handlepdfClose = () => {
    setOpenModal(false);
  }
  // const handleDownload = async (rowData) => {
  //   const formattedData = {
  //     ...rowData,
  
  //       practice_owner_name: `${rowData.practice_owner_first_name} ${rowData.practice_owner_last_name}`,
  //       point_of_contact: `${rowData.point_of_contact_first_name} ${rowData.point_of_contact_last_name}`,
  //       signature: `${rowData.url}`,
  //       triveserviceplusLink: `${rowData.triveserviceplusLink}`,
  //       thriveserviceplusprivacyLink: `${rowData.thriveserviceplusprivacyLink}`,
  //       thriveserviceplustermconditionLink: `${rowData.thriveserviceplustermconditionLink}`,
  //       signaturebase64 : rowData.signature_sign_base64
  //   };

  //   const blob = await pdf(
  //     <ThriveServicePlusPDF formData={formattedData} formFields={formFields} />
  //   ).toBlob();

  //   const blobUrl = URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = blobUrl;
  //   link.download = 'Servive Plus Form.pdf';
  //   link.click();

  //   URL.revokeObjectURL(blobUrl);
  // };

  const blockInvalidChar = e => ['.', '-','+','ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault();


  
  return (
    <React.Fragment>
      <div style={{ marginBottom: 16 }}>
        <Button className={classes.backBtn} onClick={goBack}>
          {t('Back')}
        </Button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom:"10px" }}>
            <CssTextField
              placeholder={t('Search for Ship To')}
              type="number"              
  onWheel={(e) => e.target.blur()}
              onKeyDown={blockInvalidChar}
              variant="outlined"
              autoComplete="off"
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue && searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGet();
                        }}
                      />
                    ) : (
                      <SearchOutlinedIcon className={classes.searchInputIcon} />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                if (e.target.value.length === 0) {
                  handleGet();
                }
              }}
              onClick={() => setOffset(1)}
            />

            
          </div>

      <Loader Loading={state.loading} top={"15%"}>
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
            <Table
              headings={[
                "Ship To",
                "Name",
                "Email",
                "Submitted Date",
                "Approved/Rejected By",
                "Subscription Plan",
                "Status",
                "",
              ]}
              data={data?.map((d) => [
                d?.henry_schein_account_number || "-",
                d?.practice_name || "-",
                d?.email || "-",
                d?.created_at ? moment(d.created_at).format("YYYY-MM-DD") : "-",
                d?.usermail || "-",
                getPlanName(d?.tier_service_agreement),
                <span style={{
                color: d?.status === "Processed" ? "green" : d?.status === "Rejected" ? "red" : "inherit",
                fontWeight: "bold" }}>
               {d?.status || "-"}
               </span>,
               <a
              //  key={i}
               style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
               onClick={() => {
                 setImageType(d?.url);
                 setOpenModal(true);
               }}
             >
               {t("View")}
             </a>,
              //   <IconButton
              //   aria-label="download"
              //   onClick={() => {
              //     const updatedData = {
              //       ...d,
              //       practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
              //       point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
              //       signature: `${d.url}`,
              //       triveserviceplusLink: `${d.triveserviceplusLink}`,
              //       thriveserviceplusprivacyLink: `${d.thriveserviceplusprivacyLink}`,
              //       thriveserviceplustermconditionLink: `${d.thriveserviceplustermconditionLink}`,
              //       signaturebase64 : d.signature_sign_base64
              //     };
          
              //     setPreviewData(updatedData); // Optional
              //     handleDownload(d);           // Actual download function
              //   }}
              // >
              //   <GetAppIcon />
              // </IconButton>

               
              ])}
              offset={offset}
              count={
                (count / 10) % 1 === 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />

{openModal && (
                                    <Modal
                                      className={classes.modal}
                                      open={openModal}
                                      onClose={handlepdfClose}
                                      closeAfterTransition
                                      BackdropComponent={Backdrop}
                                      BackdropProps={{
                                        timeout: 300,
                                      }}
                                    >
                                      <Fade in={openModal} timeout={300} className={classes.img}>
                                        
                                          <iframe src={imageType} width='800' height='600'></iframe>
                                       
                                      </Fade>
                                    </Modal>
                                  )}
          </Grid>
        </Grid>
      </Loader>
    </React.Fragment>
  );
}

export default History;
